<template>
  <div id="app">
     <header-bar />
     <router-view />
     <foot-bar />
  </div>
</template>

<script setup>
import HeaderBar from "../components/z-header.vue";
import FootBar from "../components/z-foot.vue";
</script>
<style lang="scss" scoped>
</style>